 /*
 * @flow
 */

// 'use strict';

// const Platform = require('Platform');
// const Parse = require('parse/react-native');
import Parse from 'parse';
// import DeviceInfo from 'react-native-device-info';
// import codePush from 'react-native-code-push';

async function currentInstallation() {
  console.log(1);
  console.log(Parse);
  const installationId = await Parse._getInstallationId();
  console.log();
  // const codePushPackage = await codePush.getCurrentPackage();

  return new Parse.Installation({
    installationId,
    appName: 'MyApp',
    deviceType: 'web',
    // appVersion: DeviceInfo.getReadableVersion(),
    // codePushPackage,

    // TODO: Get this information from the app itself
    appIdentifier: 'com.platfarm.mojitok.server.dev',
  });
}

async function updateInstallation(updates) {
  console.log(updates);
  const installation = await currentInstallation();
  console.log('before save');
  await installation.save(updates);
  console.log('after save');
}

// module.exports = { currentInstallation, updateInstallation };
export default updateInstallation;
